// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nh-0";
export var buttonContainer = "_nh-3";
export var cancelButton = "_nh-4";
export var headerSection = "_nh-6";
export var headerTitle = "_nh-9";
export var messageSideLeft = "_nh-1";
export var messageSideRight = "_nh-2";
export var orderNumberContainer = "_nh-7";
export var orderNumberLabel = "_nh-8";
export var submitButton = "_nh-5";